import React from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import Script from 'react-load-script'

import { APP_ID } from 'config'
import * as appActions from 'lib/store/app'
import * as userActions from 'lib/store/user'
import LoginScreen from './LoginScreen'

class LoginContainer extends React.PureComponent {
  static propTypes = {
    isLoading: PropTypes.bool.isRequired,
    setLoading: PropTypes.func.isRequired,
    addFacebookUserDataToUser: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired
  }

  state = {
    showLoginScreen: false
  }

  componentDidMount() {
    document.title = 'Login'

    window.fbAsyncInit = () => {
      window.FB.init({
        appId: APP_ID,
        cookie: true,
        xfbml: false,
        version: 'v2.12'
      })

      window.FB.getLoginStatus(this.handleLoginStatus)
    }
  }

  componentWillUnmount() {
    window.FB.Event.unsubscribe('auth.statusChange', this.handleLoginStatus)
  }

  handleLoginStatus = ({ status }) => {
    if (status === 'connected') {
      this.fetchFacebookData()
      return
    }

    // When user has to login with Facebook, we listen for a status change
    // and then try again.
    window.FB.Event.subscribe('auth.statusChange', this.handleLoginStatus)

    ReactDOM.unstable_batchedUpdates(() => {
      this.setState({ showLoginScreen: true })
      this.props.setLoading(false)
    })
  }

  handleError = error => {
    throw error
  }

  handleLoad = () => {
    // Intentionally left blank (required handler)
  }

  fetchFacebookData = () => {
    const fields = ['id', 'picture', 'link']
    const { referrer } = this.props.location.state || {}

    window.FB.api('/me', { fields }, response => {
      // if response does not contain user-link, request login with permissions again
      if (!response.link) {
        window.FB.Event.subscribe('auth.statusChange', this.handleLoginStatus)

        ReactDOM.unstable_batchedUpdates(() => {
          this.setState({ showLoginScreen: true })
          this.props.setLoading(false)
        })
        return
      }

      this.props.addFacebookUserDataToUser(response).then(() => {
        // If no referrer is known, fallback to matches.
        this.props.history.replace(referrer || '/matches')
      })
    })
  }

  render() {
    const { showLoginScreen } = this.state

    return (
      <React.Fragment>
        <Script
          url="https://connect.facebook.net/en_US/sdk.js"
          attributes={{ id: 'facebook-jssdk' }}
          onError={this.handleError}
          onLoad={this.handleLoad}
        />
        {showLoginScreen && <LoginScreen />}
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => ({
  isLoading: state.app.isLoading
})

const mapDispatchToProps = dispatch => ({
  setLoading: loadingState => dispatch(appActions.setLoading(loadingState)),
  addFacebookUserDataToUser: facebookUserData => dispatch(userActions.addFacebookUserData(facebookUserData))
})

export const LoginConnected = connect(mapStateToProps, mapDispatchToProps)(
  LoginContainer
)

export default withRouter(LoginConnected)



// WEBPACK FOOTER //
// ./src/components/login/LoginContainer.js